import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: 'auto',
  },
  buttonLink: {
    marginTop: 15,
    marginRight: 15,
    textTransform: 'none',
  },
})

export default useStyles
